<div class="grid-container" id="cr-grid-container">
  <div class="top-toolbar dst-toolbar">
    <div class="float-left">
      @if (taxyearLoaded) {
<ap-dropdown [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'"
                   [hideTitleOnInput]="true" [enableNgContent]="false"
                   [optionName]="'label'" [optionValue]="'value'"
                   [showSearchbox]="true" [clearSearchKeyword]="true"
                   [inputAriaLabel]="'Tax Year'"
                   (onFilterResult)="onTaxYearFilterResult($event)"
                   [(ngModel)]="selectedTaxYearItem" (onSelect)="onTaxYearChanged($event)">
      </ap-dropdown>
}
      <gtw-df-me-dropdown class="top-filter-select" [customActionCode]="32136"
        (selectedMes)="selectedCustomMeChanged($event)">
      </gtw-df-me-dropdown>
      <ap-button [compact]="true" [btnType]="'primary'" [label]="'Filter'" class="ap-mr-spacing-3"
        (onClick)="loadCustomFilteringData()"></ap-button>
      <span class="Appkit4-icon icon-view-outline"></span>
      <span class="toolbar-btn" (click)="exportToExcel()">
        <span class="Appkit4-icon icon-save-outline"></span>
        &nbsp;Export to Excel
        @if (exportingExcel) {
          <span class="ml-1"><i class="fa fa-spinner fa-spin"></i></span>
        }
      </span>
      <span class="toolbar-btn" (click)="resetAllFilters()">
        <span class="Appkit4-icon icon-refresh-outline"></span>
        &nbsp;Reset All Filters
      </span>
      <span class="Appkit4-icon icon-openinnewwindow-outline"></span>
    </div>
    <div class="float-right">
      <span>Total records: {{data.length}}</span>
      <ap-button [compact]="true" [btnType]="'primary'" class="ap-mr-spacing-3" [label]="'Disclosure Properties'" [disabled]="loading"
        (onClick)="showFilters()">
      </ap-button>
    </div>
  </div>

  <div class="dst-mat-grid-layout">
    @if (loading) {
      <div class="dst-mat-grid-loading">
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>
    }
    <div class="dst-mat-grid">
      <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort #sort="matSort"
        [multiTemplateDataRows]="true" class="dst-mat-table">
        <ng-container matColumnDef="statementId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('statementId'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('statementId'))"
            (widthChange)="onColumnWidthChange(getColByField('statementId'), $event)">
            {{ getColByField('statementId').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" class="cr-stmt-id-col" [ngStyle]="getDstColStyle(getColByField('statementId'))">
            @if (rowData.associatedStmt) {
              <a href="#" class="cr-row-toggle" (click)="toggleRowExpansion(rowData, $event)"
                [attr.aria-label]="expandedElement === rowData ? 'Collapse associated statements' : 'Expand associated statements'">
                <i [ngClass]="expandedElement === rowData ? 'pi pi-fw pi-chevron-circle-down' : 'pi pi-fw pi-chevron-circle-right'"></i>
              </a>
            }
            <dst-stmt-id-btn [gridData]="data" [rowData]="rowData" [mode]="'customReport'"
              (actionClick)="onActionClicked($event)"></dst-stmt-id-btn>
          </td>
        </ng-container>

        <ng-container matColumnDef="TAXYEAR">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('TAXYEAR'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('TAXYEAR'))"
            (widthChange)="onColumnWidthChange(getColByField('TAXYEAR'), $event)">
            {{ getColByField('TAXYEAR').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" style="text-align: center;" [ngStyle]="getDstColStyle(getColByField('TAXYEAR'))">
            <span>{{ rowData.TAXYEAR }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="formName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('formName'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('formName'))"
            (widthChange)="onColumnWidthChange(getColByField('formName'), $event)">
            {{ getColByField('formName').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('formName'))">
            <span>{{ rowData.formName }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="disclosureType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('disclosureType'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('disclosureType'))"
            (widthChange)="onColumnWidthChange(getColByField('disclosureType'), $event)">
            {{ getColByField('disclosureType').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('disclosureType'))">
            <span>{{ rowData.disclosureType }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="primaryBusiness">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('primaryBusiness'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('primaryBusiness'))"
            (widthChange)="onColumnWidthChange(getColByField('primaryBusiness'), $event)">
            {{ getColByField('primaryBusiness').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('primaryBusiness'))">
            <span>{{ rowData.primaryBusiness }}<br><span style="font-style: italic">{{ rowData.secondaryBusiness }}</span></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="secondaryBusiness">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('secondaryBusiness'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('secondaryBusiness'))"
            (widthChange)="onColumnWidthChange(getColByField('secondaryBusiness'), $event)">
            {{ getColByField('secondaryBusiness').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('secondaryBusiness'))"></td>
        </ng-container>

        <ng-container matColumnDef="primaryLeid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('primaryLeid'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('primaryLeid'))"
            (widthChange)="onColumnWidthChange(getColByField('primaryLeid'), $event)">
            {{ getColByField('primaryLeid').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('primaryLeid'))">
            <span>{{ rowData.primaryLeid }}<br><span style="font-style: italic">{{ rowData.secondaryLeid }}</span></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="secondaryLeid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('secondaryLeid'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('secondaryLeid'))"
            (widthChange)="onColumnWidthChange(getColByField('secondaryLeid'), $event)">
            {{ getColByField('secondaryLeid').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('secondaryLeid'))"></td>
        </ng-container>

        <ng-container matColumnDef="primaryEntity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('primaryEntity'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('primaryEntity'))"
            (widthChange)="onColumnWidthChange(getColByField('primaryEntity'), $event)">
            {{ getColByField('primaryEntity').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('primaryEntity'))">
            <span>{{ rowData.primaryEntity }}<br><span style="font-style: italic">{{ rowData.secondaryEntity }}</span></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="secondaryEntity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('secondaryEntity'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('secondaryEntity'))"
            (widthChange)="onColumnWidthChange(getColByField('secondaryEntity'), $event)">
            {{ getColByField('secondaryEntity').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('secondaryEntity'))"></td>
        </ng-container>

        <ng-container matColumnDef="branchLeid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('branchLeid'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('branchLeid'))"
            (widthChange)="onColumnWidthChange(getColByField('branchLeid'), $event)">
            {{ getColByField('branchLeid').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('branchLeid'))"></td>
        </ng-container>

        <ng-container matColumnDef="createdBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('createdBy'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('createdBy'))"
            (widthChange)="onColumnWidthChange(getColByField('createdBy'), $event)">
            {{ getColByField('createdBy').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('createdBy'))"></td>
        </ng-container>

        <ng-container matColumnDef="modifiedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('modifiedBy'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('modifiedBy'))"
            (widthChange)="onColumnWidthChange(getColByField('modifiedBy'), $event)">
            {{ getColByField('modifiedBy').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('modifiedBy'))"></td>
        </ng-container>

        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('createdOn'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('createdOn'))"
            (widthChange)="onColumnWidthChange(getColByField('createdOn'), $event)">
            {{ getColByField('createdOn').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('createdOn'))"></td>
        </ng-container>

        <ng-container matColumnDef="modifiedOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('modifiedOn'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('modifiedOn'))"
            (widthChange)="onColumnWidthChange(getColByField('modifiedOn'), $event)">
            {{ getColByField('modifiedOn').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('modifiedOn'))"></td>
        </ng-container>

        <ng-container matColumnDef="FilingGroup">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('FilingGroup'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('FilingGroup'))"
            (widthChange)="onColumnWidthChange(getColByField('FilingGroup'), $event)">
            {{ getColByField('FilingGroup').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('FilingGroup'))">
            <span>{{ rowData.FilingGroup }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="FilingGroupReturnType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('FilingGroupReturnType'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('FilingGroupReturnType'))"
            (widthChange)="onColumnWidthChange(getColByField('FilingGroupReturnType'), $event)">
            {{ getColByField('FilingGroupReturnType').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('FilingGroupReturnType'))">
            <span>{{ rowData.FilingGroupReturnType }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('status'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('status'))"
            (widthChange)="onColumnWidthChange(getColByField('status'), $event)">
            {{ getColByField('status').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('status'))">
            <span>{{ rowData.status }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="isQar">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('isQar'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('isQar'))"
            (widthChange)="onColumnWidthChange(getColByField('isQar'), $event)">
            {{ getColByField('isQar').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('isQar'))"></td>
        </ng-container>

        <ng-container matColumnDef="projectName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('projectName'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('projectName'))"
            (widthChange)="onColumnWidthChange(getColByField('projectName'), $event)">
            {{ getColByField('projectName').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('projectName'))">
            @if (rowData.projectName) {
              <span>
                {{ rowData.projectName }} - {{ rowData.projectStepName }}<br>
                <span style="font-style: italic">{{ rowData.PROJECTBSLACODE }}</span>
              </span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="projectStepName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('projectStepName'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('projectStepName'))"
            (widthChange)="onColumnWidthChange(getColByField('projectStepName'), $event)">
            {{ getColByField('projectStepName').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('projectStepName'))"></td>
        </ng-container>

        <ng-container matColumnDef="projectBslaName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('projectBslaName'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('projectBslaName'))"
            (widthChange)="onColumnWidthChange(getColByField('projectBslaName'), $event)">
            {{ getColByField('projectBslaName').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('projectBslaName'))"></td>
        </ng-container>

        <ng-container matColumnDef="ignoredId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('ignoredId'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('ignoredId'))"
            (widthChange)="onColumnWidthChange(getColByField('ignoredId'), $event)">
            {{ getColByField('ignoredId').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('ignoredId'))">
            <span>{{ rowData.ignoredId }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="signatureFlag">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('signatureFlag'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('signatureFlag'))"
            (widthChange)="onColumnWidthChange(getColByField('signatureFlag'), $event)">
            {{ getColByField('signatureFlag').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('signatureFlag'))">
            <span>{{ rowData.signatureFlag }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="electionFlag">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('electionFlag'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('electionFlag'))"
            (widthChange)="onColumnWidthChange(getColByField('electionFlag'), $event)">
            {{ getColByField('electionFlag').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('electionFlag'))">
            <span>{{ rowData.electionFlag }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="userActivity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('userActivity'))"
            [dstMatColumnResize]="getColWidthPx(getColByField('userActivity'))"
            (widthChange)="onColumnWidthChange(getColByField('userActivity'), $event)">
            {{ getColByField('userActivity').header }}
            <span class="dst-mat-col-resize-handle"></span>
          </th>
          <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('userActivity'))">
            <span class="text-color-primary">Created By: </span>
            {{ rowData.createdBy }}&nbsp;
            {{ rowData.createdOn ? '(' + rowData.createdOn + ')' : '' }}<br>
            <span class="text-color-primary" style="font-style: italic">Modified By: </span>
            <span style="font-style: italic">
              {{ rowData.modifiedBy }}&nbsp;
              {{ rowData.modifiedOn ? '(' + rowData.modifiedOn + ')' : '' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="statementId_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('statementId'))">
            <input type="text" [(ngModel)]="fStatementId" (input)="filterByStatementId($event)"
              class="dst-mat-col-filter" style="width: 140px">
          </th>
        </ng-container>

        <ng-container matColumnDef="TAXYEAR_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('TAXYEAR'))">
            <ap-dropdown class="dst-mat-col-filter cr-year-filter" [selectType]="'multiple'" [enableNgContent]="false"
              [list]="dropdownOptions['taxYearColumn']" [optionName]="'label'" [optionValue]="'id'"
              [listId]="'dst-grid-filter-cr-tax-year'"
              [title]="'All'" [inputAriaLabel]="'Tax year filter'" [hideTitleOnInput]="true"
              [multipleDropdownValue]="selectedTaxYearLabel"
              [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
              (onFilterResult)="onDropdownFilterResult('taxYearColumn', $event)"
              [(ngModel)]="selectedTaxYearsObj" (onSelect)="onTaxYearsChange($event.selected)">
            </ap-dropdown>
          </th>
        </ng-container>

        <ng-container matColumnDef="formName_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('formName'))">
            <input type="text" [(ngModel)]="fFormName" (input)="filterCol($event, 'formName', 'contains')"
              class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="disclosureType_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('disclosureType'))">
            <input type="text" [(ngModel)]="fDisclosureType"
              (input)="filterCol($event, 'disclosureType', 'contains')" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="primaryBusiness_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('primaryBusiness'))" style="overflow: visible">
            <gtw-df-me-dropdown class="me-filter-select" [customActionCode]="32136"
              (selectedMes)="selectedMeChanged($event)"></gtw-df-me-dropdown>
          </th>
        </ng-container>

        <ng-container matColumnDef="secondaryBusiness_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('secondaryBusiness'))">
            <input type="text" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="primaryLeid_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('primaryLeid'))">
            <input type="text" [(ngModel)]="fPrimaryLeid"
              (input)="filterCol($event, 'primaryLeid', 'startsWith')" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="secondaryLeid_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('secondaryLeid'))">
            <input type="text" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="primaryEntity_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('primaryEntity'))">
            <input type="text" [(ngModel)]="fPrimaryEntity"
              (input)="filterCol($event, 'primaryEntity', 'contains')" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="secondaryEntity_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('secondaryEntity'))">
            <input type="text" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="branchLeid_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('branchLeid'))">
            <input type="text" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="createdBy_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('createdBy'))">
            <input type="text" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="modifiedBy_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('modifiedBy'))">
            <input type="text" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="createdOn_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('createdOn'))">
            <input type="text" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="modifiedOn_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('modifiedOn'))">
            <input type="text" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="FilingGroup_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('FilingGroup'))">
            <input type="text" [(ngModel)]="fFilingGroup"
              (input)="filterCol($event, 'FilingGroup', 'startsWith')" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="FilingGroupReturnType_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('FilingGroupReturnType'))">
            <input type="text" [(ngModel)]="fFilingGroupReturnType"
              (input)="filterCol($event, 'FilingGroupReturnType', 'startsWith')" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="status_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('status'))">
            <input type="text" [(ngModel)]="fStatus" (input)="filterCol($event, 'status', 'startsWith')"
              class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="isQar_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('isQar'))">
            <input type="text" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="projectName_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('projectName'))">
            <input type="text" [(ngModel)]="fProjectName"
              (input)="filterCol($event, 'projectName', 'contains')" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="projectStepName_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('projectStepName'))">
            <input type="text" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="projectBslaName_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('projectBslaName'))">
            <input type="text" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="ignoredId_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('ignoredId'))">
            <input type="text" [(ngModel)]="fProjectName"
              (input)="filterCol($event, 'projectName', 'contains')" class="dst-mat-col-filter" disabled>
          </th>
        </ng-container>

        <ng-container matColumnDef="signatureFlag_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('signatureFlag'))">
            <input type="text" [(ngModel)]="fSignatureFlag"
              (input)="filterCol($event, 'signatureFlag', 'startsWith')" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="electionFlag_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('electionFlag'))">
            <input type="text" [(ngModel)]="fElectionFlag"
              (input)="filterCol($event, 'electionFlag', 'startsWith')" class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="userActivity_filter">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="getDstColStyle(getColByField('userActivity'))">
            <input type="text" [(ngModel)]="fCreatedBy" (input)="filterCol($event, 'createdBy', 'contains')"
              class="dst-mat-col-filter">
          </th>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let rowData" [attr.colspan]="displayedColumns.length">
            <div class="cr-expanded-panel">
              <table mat-table [dataSource]="rowData.associatedStmt" [fixedLayout]="true" class="dst-mat-table cr-child-table">
                <ng-container matColumnDef="child_statementId">
                  <th mat-header-cell *matHeaderCellDef>{{ getChildColHeader('statementId') }}</th>
                  <td mat-cell *matCellDef="let childRow" class="cr-stmt-id-col">
                    <dst-stmt-id-btn [gridData]="data" [rowData]="childRow" [mode]="'customReport'"
                      (actionClick)="onActionClicked($event)"></dst-stmt-id-btn>
                  </td>
                </ng-container>
                <ng-container matColumnDef="child_TAXYEAR">
                  <th mat-header-cell *matHeaderCellDef>{{ getChildColHeader('TAXYEAR') }}</th>
                  <td mat-cell *matCellDef="let childRow"><span>{{ childRow.TAXYEAR }}</span></td>
                </ng-container>
                <ng-container matColumnDef="child_formName">
                  <th mat-header-cell *matHeaderCellDef>{{ getChildColHeader('formName') }}</th>
                  <td mat-cell *matCellDef="let childRow"><span>{{ childRow.formName }}</span></td>
                </ng-container>
                <ng-container matColumnDef="child_disclosureType">
                  <th mat-header-cell *matHeaderCellDef>{{ getChildColHeader('disclosureType') }}</th>
                  <td mat-cell *matCellDef="let childRow"><span>{{ childRow.disclosureType }}</span></td>
                </ng-container>
                <ng-container matColumnDef="child_primaryBusiness">
                  <th mat-header-cell *matHeaderCellDef>{{ getChildColHeader('primaryBusiness') }}</th>
                  <td mat-cell *matCellDef="let childRow">
                    <span>{{ childRow.primaryBusiness }}<br><span style="font-style: italic">{{ childRow.secondaryBusiness }}</span></span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="child_primaryLeid">
                  <th mat-header-cell *matHeaderCellDef>{{ getChildColHeader('primaryLeid') }}</th>
                  <td mat-cell *matCellDef="let childRow">
                    <span>{{ childRow.primaryLeid }}<br><span style="font-style: italic">{{ childRow.secondaryLeid }}</span></span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="child_primaryEntity">
                  <th mat-header-cell *matHeaderCellDef>{{ getChildColHeader('primaryEntity') }}</th>
                  <td mat-cell *matCellDef="let childRow">
                    <span>{{ childRow.primaryEntity }}<br><span style="font-style: italic">{{ childRow.secondaryEntity }}</span></span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="child_FilingGroup">
                  <th mat-header-cell *matHeaderCellDef>{{ getChildColHeader('FilingGroup') }}</th>
                  <td mat-cell *matCellDef="let childRow"><span>{{ childRow.FilingGroup }}</span></td>
                </ng-container>
                <ng-container matColumnDef="child_FilingGroupReturnType">
                  <th mat-header-cell *matHeaderCellDef>{{ getChildColHeader('FilingGroupReturnType') }}</th>
                  <td mat-cell *matCellDef="let childRow"><span>{{ childRow.FilingGroupReturnType }}</span></td>
                </ng-container>
                <ng-container matColumnDef="child_createdBy">
                  <th mat-header-cell *matHeaderCellDef>{{ getChildColHeader('createdBy') }}</th>
                  <td mat-cell *matCellDef="let childRow">
                    <span>{{ childRow.createdBy }}<br><span style="font-style: italic">{{ childRow.modifiedBy }}</span></span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="child_status">
                  <th mat-header-cell *matHeaderCellDef>{{ getChildColHeader('status') }}</th>
                  <td mat-cell *matCellDef="let childRow"><span>{{ childRow.status }}</span></td>
                </ng-container>
                <ng-container matColumnDef="child_projectName">
                  <th mat-header-cell *matHeaderCellDef>{{ getChildColHeader('projectName') }}</th>
                  <td mat-cell *matCellDef="let childRow">
                    @if (childRow.projectName) {
                      <span>
                        {{ childRow.projectName }} - {{ childRow.projectStepName }}<br>
                        <span style="font-style: italic">{{ childRow.PROJECTBSLACODE }}</span>
                      </span>
                    }
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="childDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let childRow; columns: childDisplayedColumns;"></tr>
              </table>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 45px;"></tr>
        <tr mat-header-row *matHeaderRowDef="filterColumns; sticky: true" class="dst-mat-filter-row" style="height: 45px;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 70px;"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isExpansionDetailRow" class="cr-expanded-row"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell dst-mat-no-records" [attr.colspan]="displayedColumns.length">
            <span>No Records Found.</span>
          </td>
        </tr>
      </table>
    </div>
    <!-- MatPaginator still drives the table. Its own range label sits on the
         right and has no page numbers; the bar below is the visible footer. -->
    <mat-paginator class="cr-paginator-control" [pageSize]="rows" [hidePageSize]="true"
      aria-label="Custom report pagination">
    </mat-paginator>
    <div class="cr-paginator-bar">
      <ap-pagination
        [min]="1"
        [max]="pageCount"
        [step]="1"
        [label]="['Previous', 'Next']"
        [ngModel]="currentPage"
        (ngModelChange)="onAppkitPage($event)">
      </ap-pagination>
      <span class="cr-page-report">Showing {{ rangeStart }} to {{ rangeEnd }} of {{ recordCount }} entries</span>
    </div>
  </div>
</div>

@if (showModalViewer) {
<dst-disc-modal-viewer [rowObject]="activeRow"
  (afterModalClosed)="afterModalClosed()"></dst-disc-modal-viewer>
}
@if (showProjectTaggingModal) {
<dst-project-tagging [rowObject]="activeRow"
  (afterModalClosed)="afterProjectTaggingModalClosed()"></dst-project-tagging>
}
@if (showCopyRepModal) {
<dst-copy-replicate [rowObject]="activeRow" [mode]="copyMode"
  (afterModalClosed)="afterCopyRepModalClosed()"></dst-copy-replicate>
}
@if (showGridFilters) {
  <ap-modal #customReportFilterModal
    [appModalId]="'custom-report-filters'"
    [ariaLabel]="'Filter Custom Reports'"
    [title]="'Filter Custom Reports'"
    [closable]="true"
    [alignment]="'top'"
    [style]="{'width': '40vw'}"
    [contentStyle]="{'min-height': '32.8125rem'}"
    (onClose)="closeGridFilters('custom-report-filters')">
    <div class="row">
      <div class="col-2">Tax Year</div>
      <div class="col-10">
        <ap-dropdown class="p-column-filter" [selectType]="'multiple'" [enableNgContent]="false"
          [list]="dropdownOptions['taxYearPanel']" [optionName]="'label'" [optionValue]="'id'"
          [title]="'Select Tax Year'" [inputAriaLabel]="'Select Tax Year'" [hideTitleOnInput]="true"
          [multipleDropdownValue]="selectedTaxYearLabel"
          [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
          (onFilterResult)="onDropdownFilterResult('taxYearPanel', $event)"
          [(ngModel)]="selectedTaxYearsObj" [disabled]="true"
          (onSelect)="onTaxYearsFilterChange($event.selected)">
        </ap-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-2">Disclosure</div>
      <div class="col-10">
        <ap-dropdown class="p-column-filter" [selectType]="'multiple'" [enableNgContent]="false"
          [list]="dropdownOptions['disclosure']" [optionName]="'formName'" [optionValue]="'formId'"
          [title]="'All'" [inputAriaLabel]="'Disclosure filter'" [hideTitleOnInput]="true"
          [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
          (onFilterResult)="onDropdownFilterResult('disclosure', $event)"
          [(ngModel)]="selectedDisclosuresObj" (onSelect)="onDiscFilterChange($event.selected)">
        </ap-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-2">Business</div>
      <div class="col-10">
        <gtw-df-me-dropdown class="me-filter-select" [customActionCode]="32136"
          (selectedMes)="selectedMeFilterChanged($event)"></gtw-df-me-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-2">Filing Status</div>
      <div class="col-10">
        <ap-dropdown appendTo="body" [list]="fStatusListItems" [selectType]="'single'"
          [title]="'Filing Status'" [hideTitleOnInput]="true" [inputAriaLabel]="'Filing Status'"
          [(ngModel)]="selectedFStatusItem" (onSelect)="onFStatusSelect($event)">
          @for (item of fStatusListItems; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'Filing Status')"
              (onSelectItem)="onFilterSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-2">QAR Status</div>
      <div class="col-10">
        <ap-dropdown appendTo="body" [list]="QARStatusListItems" [selectType]="'single'"
          [title]="'QAR Status'" [hideTitleOnInput]="true" [inputAriaLabel]="'QAR Status'"
          [(ngModel)]="selectedQARStatusItem" (onSelect)="onQARStatusSelect($event)">
          @for (item of QARStatusListItems; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'QAR Status')"
              (onSelectItem)="onFilterSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-2">Signature Flag</div>
      <div class="col-10">
        <ap-dropdown appendTo="body" [list]="sigElecFlagListItems" [selectType]="'single'"
          [title]="'Signature Flag'" [hideTitleOnInput]="true" [inputAriaLabel]="'Signature Flag'"
          [(ngModel)]="selectedSigFlagItem" (onSelect)="onSigFlagSelect($event)">
          @for (item of sigElecFlagListItems; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'Signature Flag')"
              (onSelectItem)="onFilterSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-2">Election Flag</div>
      <div class="col-10">
        <ap-dropdown appendTo="body" [list]="sigElecFlagListItems" [selectType]="'single'"
          [title]="'Election Flag'" [hideTitleOnInput]="true" [inputAriaLabel]="'Election Flag'"
          [(ngModel)]="selectedElecFlagItem" (onSelect)="onElecFlagSelect($event)">
          @for (item of sigElecFlagListItems; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'Election Flag')"
              (onSelectItem)="onFilterSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
    </div>
    <ng-template ngTemplate="footer">
      <ap-button [compact]="true" [btnType]="'primary'" [label]="'Reset'" class="ap-mr-spacing-3"
        (onClick)="resetGridFilters()"></ap-button>
      <ap-button [compact]="true" [btnType]="'primary'" [label]="'Close'" class="ap-mr-spacing-3"
        (onClick)="closeGridFilters('custom-report-filters')"></ap-button>
      <ap-button [compact]="true" [btnType]="'primary'" [label]="'Filter'" class="ap-mr-spacing-3"
        (onClick)="refresh()"></ap-button>
    </ng-template>
  </ap-modal>
}
